import { render, staticRenderFns } from "./navigationDefault.vue?vue&type=template&id=44c9c1d4&"
import script from "./navigationDefault.vue?vue&type=script&lang=js&"
export * from "./navigationDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports